import * as React from 'react';

const ProfileContext = React.createContext(null);

export type BaseModel = null | {
    query_token?: string;
    query_email?: string;
    companyPec?: string; // ??
    campaign: {
        SellingInfo: {
            LcmsContractName: string;
        }
    };
    article: {
        DiscountedAmount: number;
    };
    code: string;
    email: string;
    name: string;
    fiscalCode: string;
    surname: string;
    accepted: boolean | null;
    isLegalRepresentative: boolean | null;
    expired: boolean | null;
    company: {
        vatCode: string;
        fiscalCode: string;
        description: string;
        lastName: string;
        cciaaRea: string;
        phoneNumber: string;
        faxNumber: string;
        email: string;
        pec: string;
        postalCode: string;
        address: string;
        city: string;
        province: string;
        region: string;
        country: string;
        code: string;
        name: string;
    };
};

export const ProfileContextProvider = ({ children }) => {

    const [profile, setProfile] = React.useState<BaseModel>(null);

    return (
        <ProfileContext.Provider value={[profile, setProfile]}>
            {children}
        </ProfileContext.Provider>
    );
};

export const useProfileContext:
    () => [BaseModel, React.Dispatch<React.SetStateAction<BaseModel>>] =
    () => React.useContext(ProfileContext);

